module.exports = __webpack_public_path__ + "img/3.d39e5643.jpg";